import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../shared/modals/modal.component';

const CannotUploadMessageModal = ({ hideModal, isVisible }) => (
  <Modal
    className="upload-message-modal"
    dismissText="Close"
    closeAction={hideModal}
    dismissAction={hideModal}
    isVisible={isVisible}
  >
    <div>
      Unable to load trial balance. Prior to loading a trial balance, the following must occur:
      <ul>
        <li>An entity must be chosen from the list of available tax provisions.</li>
        <li>The period selected must be the current period.</li>
        <li>The provision must not be associated with a connection.</li>
        <li>The provision must have at least one enabled obligation.</li>
      </ul>
    </div>
  </Modal>
);

CannotUploadMessageModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

export default CannotUploadMessageModal;
